import React, { useEffect } from "react";
import { Loader2 } from "lucide-react";

const DESTINO = "https://cabeleireirocientificoformulador.com/";

/** Página pública da IEP que leva à página de vendas do curso Cabeleireiro Científico Formulador. */
export default function CursoCabeleireiro() {
  useEffect(() => { document.title = "Cabeleireiro Científico Formulador"; const t = setTimeout(() => window.location.replace(DESTINO), 400); return () => clearTimeout(t); }, []);
  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-6 text-center" data-testid="curso-cabeleireiro">
      <div className="max-w-sm">
        <Loader2 className="h-8 w-8 animate-spin text-[#1E9E2A] mx-auto" />
        <h1 className="font-display text-xl font-bold text-slate-900 mt-4">Cabeleireiro Científico Formulador</h1>
        <p className="text-sm text-slate-500 mt-1">Abrindo a página do curso…</p>
        <a href={DESTINO} className="inline-block mt-5 px-5 py-2.5 rounded-full bg-[#1E9E2A] text-white font-semibold text-sm">Se não abrir, toque aqui</a>
      </div>
    </div>
  );
}
